import {ChangeDetectionStrategy, Component, QueryList, ViewChildren} from "@angular/core";
import {NbTooltipDirective, NbTrigger} from "@nebular/theme";

@Component({
    selector: 'dekra-billing-data',
    templateUrl: './dekra-billing-data.template.html',
    styleUrls: ['./dekra-billing-data.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DekraBillingDataComponent {

	readonly billingData = {
		DEKRA_ADDRESS: 'Dekra Certification, Inc., P.O. Box 85394, Minneapolis, MN 55485-9394',
		PAYMENT_INFORMATION: 'Wells Fargo Bank, N.A, 420 Montgomery St, San Francisco, CA 94104',
		ACCOUNT_NUMBER: '4943717165',
		ROUTING_NUMBER: '61000227',
		DOMESTIC_NUMBER: '121000248',
		SWIFT_CODE: 'WFBIUS6S',
		TAX_ID: '23-2689662',
		DUNS_NUMBER: '876862343',
		CAGE_CODE: '3BQZ3'
	};

	readonly noop: NbTrigger = NbTrigger.NOOP;

	@ViewChildren(NbTooltipDirective) tooltips: QueryList<NbTooltipDirective>;

	toggleTooltip(key: string) {
		const index = Object.keys(this.billingData).indexOf(key);

		this.tooltips.find((item, i) => index == i).show();
		setTimeout(() => this.tooltips.find((item, i) => index == i).hide(), 500);
	}
}
